import { queryOptions } from '@tanstack/react-query';
import type { HevitonApiAppLegacy } from '@heviton/heviton-api-app-legacy';
import { USER_PROFILE_QUERY_KEY } from '@/shared/api';
import { fromRawUser } from '@/shared/data-mappers';
import type { User } from '@/shared/data-types';

/**
 * user 프로필 query 정의 SSOT (queryKey + queryFn).
 *
 * queryFn = BE 호출 → `fromRawUser` 순수 변환. BE 응답 invariant 검증 없음 (계약 신뢰,
 * optional/null 방어는 매퍼가 담당, ADR `domain-ssot` §5).
 *
 * staleTime / gcTime 은 queryClient default 사용 — 도메인별 캐시 정책 정립 후 재검토.
 */
export const userProfileQueryOptions = (api: HevitonApiAppLegacy) =>
  queryOptions<User>({
    queryKey: USER_PROFILE_QUERY_KEY,
    queryFn: async ({ signal }) => fromRawUser(await api.user.getProfile({ signal })),
  });
